export const dmCalls = ({ child }) => {
  child.call('removeElement', { id: 'settingsBtn' });

  // dm go back after access denied
  child.call('removeElement', {
    querySelector:
      '.btn-toolbar.vertical-top-margin .btn.btn-lg.btn-wide-lg.btn-secondary',
  });

  child.call('removeElement', {
    querySelector:
      '.btn-toolbar.vertical-top-margin .btn.btn-lg.btn-wide-lg.btn-primary.disabled',
  });
};
